import { Component, Inject, Input, OnChanges, SimpleChanges, ViewChild, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { DomSanitizer } from '@angular/platform-browser';
import { elementAt } from "rxjs/operators";
import { HostListener } from "@angular/core"
import { text } from "@angular/core/src/render3/instructions";

@Component({
    selector: "statement",
    template: require('./statement.component.html'),
    styles: [require('./statement.component.css')]
})
export class StatementComponent implements OnChanges {
    report: CollisionReport;

    screenHeight: any;
    screenWidth: any;
    textcontainerwidth: any;
    event: any;

    @ViewChild(SignaturePad) DiagramPad: SignaturePad;

    private DiagramPadOptions: Object = {
        'minWidth': 5,
        'canvasWidth': window.innerWidth - 16,
        'canvasHeight': window.innerHeight / 2
    };

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private domSanitizer: DomSanitizer) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        this.DiagramPad = <SignaturePad>{};

        document.body.scrollTop = 0;

        this.getScreenSize();

        if (this.report.CollisionDescription != null) {
            this.report.CollisionDescription = this.report.CollisionDescription.replace(" %%%% Location = ", "");
        }

        if (this.report.CollisionLocation != null) {
            if (this.report.R1Address == null && this.report.CollisionLocation.R1Address != null) {
                this.report.R1Address = this.report.CollisionLocation.R1Address;
            }

            if (this.report.R2Address == null && this.report.CollisionLocation.R2Address != null) {
                this.report.R2Address = this.report.CollisionLocation.R2Address;
            }
        }
    }

    ngAfterViewInit() {
    }

    diagramDrawComplete() {
    }

    drawStart() {
        // will be notified of szimek/signature_pad's onBegin event
    }

    getScreenSize() {
        var textContainer = document.getElementById('textContainer');

        if (textContainer != null) {
            textContainer.style.width = (window.innerWidth/5).toString();
        }

        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    onResize(event: any) {
        
        this.screenHeight = window.innerHeight - 10;
        this.screenWidth = window.innerWidth - 10;

        var textContainer = document.getElementById('textContainer');

        if (textContainer != null) {
            textContainer.style.width = (window.innerWidth / 5).toString();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
            }
        }
        else
            console.log("Undefined");
    }

    addDiagram() {
        this.report.Diagram = this.DiagramPad.toDataURL();
    }

    deleteDiagram() {
        this.report.Diagram = "";
    }

    onSpeedBlur() {
        try {
            this.report.ApproximateSpeed = parseInt(this.report.ApproximateSpeed.toString(), 10);
        }
        catch {
            this.report.ApproximateSpeed = 0;
        }
    }

    addtoStatement() {
        //var location = null;

        //location = (<HTMLInputElement>document.getElementById("Location")).value

        //if (location != null) {
        //    var statement = this.report.CollisionDescription;
        //    this.report.CollisionDescription = statement + " %%%% Location = " + location + "";  
        //}
        var statement = this.report.CollisionDescription;
        this.report.CollisionDescription = statement + " %%%% Location = " +  "";  
    }

    addDiagramOnSubmit() {
        if (this.report.Diagram == null || this.report.Diagram == "")
        {
            this.addDiagram();
        }        
    }

    onBack(): void {
        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            this.BackAndPost("trafficevent");
        }
        else {
            this.BackAndPost("prequalificationdriver");
        }
    }

    private BackAndPost(page: string): void {
        if (this.isValid()) {
            this.report.CurrentPage = page;
            //this.appcomponent.setReport(this.report);
            this.router.navigate([page]);
        }
    }

    onSubmit(): void {
        //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        this.addDiagramOnSubmit();
        this.addtoStatement();

        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            this.ValidateAndPost("counsellorreview")
        }
        else {
            this.ValidateAndPost("owner");
        }
    }

    private ValidateAndPost(page: string) {
        if (this.isValid()) {
            if (this.report.CollisionLocation == null) {
                this.report.CollisionLocation = <GeoLocation>{};
            }
            this.report.CollisionLocation.R1Address = this.report.R1Address;
            this.report.CollisionLocation.R2Address = this.report.R2Address;
            this.report.IsStatementPageValid = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            this.router.navigate([page]);
        }
    }

    isValid(): boolean {
        return true;
    }

    numberOnly(event: any): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                if (typeof v.EntityType == 'undefined' || v.EntityType == null || v.EntityType == "") {
                    this.router.navigate(["home"]);
                }
                this.report = v;
            });
    }
}